export function PageHeader({ title }: { title: string }) {
  return (
    <div className="row align-items-center  justify-content-between">
      <div className="col content-box-title">
        <div>
          <p className="text-capitalize mb-0 text-green-200">{title}</p>
        </div>
      </div>
    </div>
  );
}
